import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { useAuthContext } from '@myphx-engineering/auth/client';
import { Box, Button } from '@myphx-engineering/phx-design-system';

import { useMaintenanceStatus } from '../unauth-home/hooks/use-maintenance-status';

export const SignUpButton = () => {
    const { t } = useTranslation();
    const { disableAuthFlows, signUp } = useAuthContext();
    const location = useLocation();
    const { isMaintenanceActive } = useMaintenanceStatus();

    return (
        <Box mr="sm" onClick={() => signUp(location.pathname)}>
            <Button
                disabled={isMaintenanceActive || disableAuthFlows}
                size="sm"
            >
                {t('unauth.header.signUp')}
            </Button>
        </Box>
    );
};
